import { render, staticRenderFns } from "./info_card.vue?vue&type=template&id=4ac0044d&scoped=true"
import script from "./info_card.vue?vue&type=script&lang=js"
export * from "./info_card.vue?vue&type=script&lang=js"
import style0 from "./info_card.vue?vue&type=style&index=0&id=4ac0044d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac0044d",
  null
  
)

export default component.exports